import type { TConstraints } from '@feathr/rachis';

import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

/**
 * Interface for seed segment targetables (lookalike)
 */
export interface ISeedSegmentTargetable extends ITargetableBase {
  _cls: TargetableClass.seed_segment;
  seed_segment: string;
}

/**
 * SeedSegmentTargetable class for seed segment targetables (lookalike)
 */
export class SeedSegmentTargetable extends TargetableBase<ISeedSegmentTargetable> {
  public override className = 'Targetable.SeedSegmentTargetable';

  public override getDefaults(): Partial<ISeedSegmentTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.seed_segment,
    };
  }

  public override get constraints(): TConstraints<ISeedSegmentTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.seed_segment],
      },
      seed_segment: {
        presence: {
          allowEmpty: false,
          message: '^Please add a seed group to your target.',
        },
      },
    };
  }
}
